module.exports = __webpack_public_path__ + "img/lt-svb.bb8603b6.png";